import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { InkApi } from './ink-api';

export class ModelInkApiBase {
  private _get: ReturnType<InkApi['get']>;
  private _post: ReturnType<InkApi['post']>;
  private _delete: ReturnType<InkApi['delete']>;
  private _patch: ReturnType<InkApi['patch']>;
  private _put: ReturnType<InkApi['put']>;

  constructor(
    api: InkApi,
    private model: string
  ) {
    this._get = api.get(this.model);
    this._post = api.post(this.model);
    this._delete = api.delete(this.model);
    this._patch = api.patch(this.model);
    this._put = api.put(this.model);
  }

  protected get<T>(path: string, params?: HttpParams): Observable<T> {
    return this._get(path, params) as Observable<T>;
  }

  protected post<T>(path: string, body: object = {}, params?: HttpParams): Observable<T> {
    return this._post(path, body, params) as Observable<T>;
  }

  protected delete<T>(path: string, params?: HttpParams): Observable<T> {
    return this._delete(path, params) as Observable<T>;
  }

  protected patch<T>(path: string, body: object = {}, params?: HttpParams): Observable<T> {
    return this._patch(path, body, params) as Observable<T>;
  }

  protected put<T>(path: string, body: object = {}, params?: HttpParams): Observable<T> {
    return this._put(path, body, params) as Observable<T>;
  }

  protected _getHttpParams(paramsObj: {
    [key: string]: string | number | boolean | (string | number | boolean)[] | object;
  }): HttpParams {
    const definedParams = Object.entries(paramsObj).reduce((acc, [key, value]) => {
      if (value === undefined) return acc;

      if (Array.isArray(value) || !['string', 'number', 'boolean'].includes(typeof value)) {
        acc[key] = JSON.stringify(value);
        return acc;
      }

      acc[key] = value;
      return acc;
    }, {});

    return new HttpParams({ fromObject: definedParams });
  }
}
